import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ProveedorFormModal = ({ show, onHide, onSubmit, isSubmitting = false }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    contacto: "",
    telefono: "",
    email: "",
    especialidad: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [generalError, setGeneralError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors({});
    setGeneralError("");

    try {
      await onSubmit(formData);
      // Reset form on success
      setFormData({
        nombre: "",
        contacto: "",
        telefono: "",
        email: "",
        especialidad: "",
      });
    } catch (err) {
      console.error("Error en formulario de proveedor:", err);
      if (err.response?.data?.errors) {
        const errors = err.response.data.errors;
        const fieldErrors = {};
        let generalErr = "";
        errors.forEach((error) => {
          if (error.attr && error.attr !== "non_field_errors") {
            fieldErrors[error.attr] = error.detail;
          } else {
            generalErr += error.detail + " ";
          }
        });
        setFormErrors(fieldErrors);
        if (generalErr) setGeneralError(generalErr.trim());
      } else if (err.response?.data?.detail) {
        setGeneralError(err.response.data.detail);
      } else {
        setGeneralError("Error al guardar el proveedor. Intente nuevamente.");
      }
    }
  };

  const handleClose = () => {
    setFormErrors({});
    setGeneralError("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Agregar Proveedor de Mantenimiento</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {generalError && (
            <div className="alert alert-danger" role="alert">
              {generalError}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Nombre *</Form.Label>
            <Form.Control
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Nombre del proveedor"
              required
              isInvalid={!!formErrors.nombre}
            />
            {formErrors.nombre && (
              <Form.Control.Feedback type="invalid">
                {formErrors.nombre}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Contacto</Form.Label>
            <Form.Control
              type="text"
              name="contacto"
              value={formData.contacto}
              onChange={handleChange}
              placeholder="Nombre de la persona de contacto"
              isInvalid={!!formErrors.contacto}
            />
            {formErrors.contacto && (
              <Form.Control.Feedback type="invalid">
                {formErrors.contacto}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Teléfono</Form.Label>
            <Form.Control
              type="text"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              placeholder="Teléfono de contacto"
              isInvalid={!!formErrors.telefono}
            />
            {formErrors.telefono && (
              <Form.Control.Feedback type="invalid">
                {formErrors.telefono}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Correo electrónico"
              isInvalid={!!formErrors.email}
            />
            {formErrors.email && (
              <Form.Control.Feedback type="invalid">
                {formErrors.email}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Especialidad</Form.Label>
            <Form.Control
              type="text"
              name="especialidad"
              value={formData.especialidad}
              onChange={handleChange}
              placeholder="Ej: Mantenimiento de mobiliario"
              isInvalid={!!formErrors.especialidad}
            />
            {formErrors.especialidad && (
              <Form.Control.Feedback type="invalid">
                {formErrors.especialidad}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Guardando..." : "Guardar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ProveedorFormModal;
